<div class="text-center mb-5">
    <h1 class="fw-bold mb-3">
        Accepting Invitation
    </h1>
    <div class="spinner-border spinner-border-lg" role="status">
        <span class="visually-hidden">Processing...</span>
    </div>
</div>
